export enum ProjectExportActionUiEnum {
  PIN = 'PIN',
  DOWNLOAD = 'DOWNLOAD',
  DELETE = 'DELETE',
  UNPIN = 'UNPIN',
  EDIT = 'EDIT',
  VIEW = 'VIEW',
  RUN = 'RUN',
  SAVE = 'SAVE',
}
